import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image, heading,text,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-one zigzag-align" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75.0943396226415%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a54717e7b713bd0dc17cc263da9aa08f/dda86/lowCode_Image_Desktop.webp 265w", "/document-services/static/a54717e7b713bd0dc17cc263da9aa08f/010e6/lowCode_Image_Desktop.webp 530w", "/document-services/static/a54717e7b713bd0dc17cc263da9aa08f/cf465/lowCode_Image_Desktop.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a54717e7b713bd0dc17cc263da9aa08f/35d86/lowCode_Image_Desktop.jpg 265w", "/document-services/static/a54717e7b713bd0dc17cc263da9aa08f/7d9a0/lowCode_Image_Desktop.jpg 530w", "/document-services/static/a54717e7b713bd0dc17cc263da9aa08f/a24e6/lowCode_Image_Desktop.jpg 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/a54717e7b713bd0dc17cc263da9aa08f/a24e6/lowCode_Image_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "low-code-document-automations"
    }}>{`Low-code document automations.`}</h3>
    <p>{`With the Adobe PDF Services connector, select from over twenty PDF API actions such as PDF Extract, Document Generation, Create PDF, Convert PDF, and many more.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/connectors/adobepdftools/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="heading,text,buttons,image" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-two zigzag-align" mdxType="TextBlock" />
    <h3 {...{
      "id": "end-to-end-workflows-complete-with-a-signature"
    }}>{`End-to-end workflows, complete with a signature.`}</h3>
    <p>{`Agreements, contracts, offer letters – you name it. Easily build workflows that need e-signatures with the Adobe Acrobat Sign connector.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://powerautomate.microsoft.com/en-us/connectors/details/shared_adobesign/adobe-sign"
        }}>{`Learn more`}</a></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75.0943396226415%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0c6c8de949cabe2c89a697fbdbc007da/dda86/endToEnd_Image_Desktop.webp 265w", "/document-services/static/0c6c8de949cabe2c89a697fbdbc007da/010e6/endToEnd_Image_Desktop.webp 530w", "/document-services/static/0c6c8de949cabe2c89a697fbdbc007da/cf465/endToEnd_Image_Desktop.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0c6c8de949cabe2c89a697fbdbc007da/35d86/endToEnd_Image_Desktop.jpg 265w", "/document-services/static/0c6c8de949cabe2c89a697fbdbc007da/7d9a0/endToEnd_Image_Desktop.jpg 530w", "/document-services/static/0c6c8de949cabe2c89a697fbdbc007da/a24e6/endToEnd_Image_Desktop.jpg 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/0c6c8de949cabe2c89a697fbdbc007da/a24e6/endToEnd_Image_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image, heading,text,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-three zigzag-align" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75.0943396226415%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/788daf848e8f8300713a9b6130012a25/dda86/simplify_Image_Desktop.webp 265w", "/document-services/static/788daf848e8f8300713a9b6130012a25/010e6/simplify_Image_Desktop.webp 530w", "/document-services/static/788daf848e8f8300713a9b6130012a25/cf465/simplify_Image_Desktop.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/788daf848e8f8300713a9b6130012a25/35d86/simplify_Image_Desktop.jpg 265w", "/document-services/static/788daf848e8f8300713a9b6130012a25/7d9a0/simplify_Image_Desktop.jpg 530w", "/document-services/static/788daf848e8f8300713a9b6130012a25/a24e6/simplify_Image_Desktop.jpg 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/788daf848e8f8300713a9b6130012a25/a24e6/simplify_Image_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "simplify-workflows-with-templates"
    }}>{`Simplify workflows with templates.`}</h3>
    <p>{`Get started quickly with 75+ ready-to-use templates for workflows using Adobe PDF Services and Adobe Acrobat Sign connectors.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://powerautomate.microsoft.com/en-US/connectors/details/shared_adobepdftools/adobe-pdf-services/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="heading,text,buttons,image" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-four zigzag-align" mdxType="TextBlock" />
    <h3 {...{
      "id": "easily-incorporate-forms-through-adobe-experience-manager"
    }}>{`Easily incorporate forms through Adobe Experience Manager.`}</h3>
    <p>{`Integrate Microsoft Dynamics and Power Automate with Adobe Experience Manager Forms for form review workflows. Deliver seamless enrollment experiences with Adobe and Microsoft solutions.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/experience-manager-learn/cloud-service/forms/forms-cs-and-power-automate/integrate-formscs-power-automate.html?lang=en"
        }}>{`Learn more`}</a></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75.0943396226415%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/fbf7e5661b4354da2d76ac07dd847f2e/dda86/forms_Image_Desktop.webp 265w", "/document-services/static/fbf7e5661b4354da2d76ac07dd847f2e/010e6/forms_Image_Desktop.webp 530w", "/document-services/static/fbf7e5661b4354da2d76ac07dd847f2e/cf465/forms_Image_Desktop.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/fbf7e5661b4354da2d76ac07dd847f2e/35d86/forms_Image_Desktop.jpg 265w", "/document-services/static/fbf7e5661b4354da2d76ac07dd847f2e/7d9a0/forms_Image_Desktop.jpg 530w", "/document-services/static/fbf7e5661b4354da2d76ac07dd847f2e/a24e6/forms_Image_Desktop.jpg 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/fbf7e5661b4354da2d76ac07dd847f2e/a24e6/forms_Image_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image, heading,text" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-five zigzag-align" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75.0943396226415%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/d0bd295afdf87a227fcb12acecadf576/dda86/api_Image_Desktop.webp 265w", "/document-services/static/d0bd295afdf87a227fcb12acecadf576/010e6/api_Image_Desktop.webp 530w", "/document-services/static/d0bd295afdf87a227fcb12acecadf576/cf465/api_Image_Desktop.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/d0bd295afdf87a227fcb12acecadf576/35d86/api_Image_Desktop.jpg 265w", "/document-services/static/d0bd295afdf87a227fcb12acecadf576/7d9a0/api_Image_Desktop.jpg 530w", "/document-services/static/d0bd295afdf87a227fcb12acecadf576/a24e6/api_Image_Desktop.jpg 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/d0bd295afdf87a227fcb12acecadf576/a24e6/api_Image_Desktop.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "build-automations-with-extensibility"
    }}>{`Build automations with extensibility.`}</h3>
    <p>{`Quickly extend your applications through hundreds of connectors in Microsoft Dataverse, Logic Apps, and more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      